module.exports = __webpack_public_path__ + "img/hourglass.0e69ac96.svg";